import React, { useState, useEffect } from "react";
import "./RoomsCarousel.css";
import { IKImage } from "imagekitio-react";
import { ArrowBackIos, ArrowForwardIos, Close } from "@mui/icons-material";

interface Props {
  images: string[];
  initialIndex?: number;
  onClose: () => void;
}

const RoomCarousel: React.FC<Props> = ({ images, initialIndex = 0, onClose }) => {
  const [slide, setSlide] = useState(initialIndex);
  const urlEndpoint = "https://ik.imagekit.io/kimchel";

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowRight") setSlide((prev) => (prev + 1) % images.length);
      else if (e.key === "ArrowLeft") setSlide((prev) => (prev - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose, images.length]);

  return (
    <div className="carouselOverlay" onClick={onClose}>
      <div className="carouselContainer" onClick={(e) => e.stopPropagation()}>

        {/* Top bar: counter + close */}
        <div className="carouselTopBar">
          <span className="carouselCounter">{slide + 1} / {images.length}</span>
          <button className="carouselClose" onClick={onClose} aria-label="Close">
            <Close />
          </button>
        </div>

        {/* Image row with side nav buttons */}
        <div className="carouselRow">
          <button
            className="carouselNav carouselNav-prev"
            onClick={() => setSlide((prev) => (prev - 1 + images.length) % images.length)}
            aria-label="Previous"
          >
            <ArrowBackIos />
          </button>

          <div className="carouselImageWrap">
            {images.map((image, index) => (
              <IKImage
                key={index}
                urlEndpoint={urlEndpoint}
                path={image}
                alt={`Photo ${index + 1}`}
                className={slide === index ? "carouselImg" : "carouselImg carouselImg-hidden"}
              />
            ))}
          </div>

          <button
            className="carouselNav carouselNav-next"
            onClick={() => setSlide((prev) => (prev + 1) % images.length)}
            aria-label="Next"
          >
            <ArrowForwardIos />
          </button>
        </div>

        {/* Dots */}
        <div className="carouselDots">
          {images.map((_, index) => (
            <button
              key={index}
              className={slide === index ? "carouselDot carouselDot-active" : "carouselDot"}
              onClick={() => setSlide(index)}
              aria-label={`Go to photo ${index + 1}`}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default RoomCarousel;
